var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-y mr-8"},[_vm._t("prefix"),_c('img',{staticClass:"mx-8",attrs:{"src":require(("@/assets/icons/" + _vm.level + ".svg")),"alt":"#","width":_vm.width}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }